import { Component } from '@angular/core';
import { FeedbackPlatformNominationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Nominations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformnomination-form',
    templateUrl: './feedbackplatformnomination.form.component.html'
})
export class FeedbackPlatformNominationFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformNominationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'nominationResponses', sectionName: 'Nomination Responses', isExpanded: false }
        ]);
    }
}

